import { render, staticRenderFns } from "./goodsReviewDetail.vue?vue&type=template&id=406bf602&"
import script from "./goodsReviewDetail.vue?vue&type=script&lang=js&"
export * from "./goodsReviewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports